module.exports = __webpack_public_path__ + "img/huge-invest.2b1bbfa6.svg";